import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";

import BasePage from "../components/test_controller/dashboard/BasePage";
import NotFoundPage from "@components/common/NotFoundPage";
import { checkRole, isLoggedIn } from "../utils/CommonUtil";
import { setPostLoginRedirect } from "@utils/auth";

type RoleAccess = "pending" | "unauthenticated" | "forbidden" | "allowed";

interface RoleRouteProps {
  component: React.ComponentType<any>;
  roles: string[];
  [key: string]: any; // Allow additional props
}

export default function RoleRoute({ component: Component, roles, ...rest }: RoleRouteProps) {
  const [access, setAccess] = useState<RoleAccess>("pending");
  const { pathname, search, hash } = useLocation();
  const requestedPath = `${pathname}${search}${hash}`;
  const allowedRoles = roles.join(",");

  useEffect(() => {
    if (!isLoggedIn()) {
      setPostLoginRedirect(requestedPath);
      setAccess("unauthenticated");
      return;
    }
    setAccess(checkRole(allowedRoles.split(",")) ? "allowed" : "forbidden");
  }, [requestedPath, allowedRoles]);

  if (access === "pending") return null;

  if (access === "unauthenticated") {
    return <Navigate to="/login" replace state={{ from: requestedPath }} />;
  }

  if (access === "forbidden") {
    return <NotFoundPage variant="noAccess" />;
  }

  return <BasePage component={<Component {...rest} />} />;
}
